(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("bn", [], factory);
	else if(typeof exports === 'object')
		exports["bn"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["bn"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 